import React from 'react';
import classNames from 'classnames/bind';
import properties from '../../../../modules/ajio-util/properties';
import styles from './DesktopAccordion.pcss';
import Image from '../../../atoms/ImageView';

const cx = classNames.bind(styles);

const DesktopAccordion = props => {
  const { giftsData = [] } = props;
  return (
    <>
      <div className={cx('accordion-container')}>
        {giftsData?.map((list, index) => {
          return (
            <div className={cx('container')} style={{ marginTop: !list?.hasGift && '46px' }}>
              {list?.hasGift && (
                <div className={cx('accordion-congratulations-text')}>
                  <p>{list?.bannerText}</p>
                </div>
              )}
              <div className={cx('head-data')}>
                <p>{list?.giftValueText}</p>
                <p>{list?.orderValueRangeText}</p>
              </div>
              <div className={cx('accordin-data-container', list?.hasGift && 'accordion-matched')}>
                {list?.offers?.map(data => {
                  return (
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div
                        className={cx('accordion-image-holder')}
                        onClick={() => {
                          window.location.href = data?.plpLink;
                        }}
                      >
                        <Image src={data?.bannerImageURL} className={cx('accordion-gift-image')} />
                      </div>
                      <div className={cx('accordion-gift-data')}>
                        <p>{data?.label}</p>
                        <p>
                          <span>{data?.value}</span>
                          <span>FREE</span>
                        </p>
                        <p>{data?.fulfillmentText}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
              {index === 0 && list?.nudgeText ? (
                <div className={cx('accordion-alert')}>
                  <Image
                    src={`${properties.getProperty('imageBaseUrl')}/static/img/nudgeBagImage.webp`}
                    className={cx('nudge-icon')}
                    alt='Bag image'
                  />
                  <p>{list?.nudgeText}</p>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DesktopAccordion;
